import { CORE_SOURCES, isCoreSourceType, } from '#pplx/frontend/apps/ask/sources/coreSourcesConfig.js';
/**
 * @deprecated use getSourceDescription from useSources instead
 */
export const getSourceDescription = (source, intl) => {
    if (isCoreSourceType(source)) {
        return CORE_SOURCES[source].description(intl);
    }
    return undefined;
};
//# sourceMappingURL=getSourceDescription.js.map